<app-header *ngIf="showHeader" [user]="user$ | async" [isLoggedIn]="isLoggedIn$ | async"></app-header>
<div [@routerAnimation]="getRouteAnimation(router)">
  <router-outlet #router="outlet"></router-outlet>
</div>
<app-footer *ngIf="showFooter"></app-footer>
